import React from 'react';
import HeroSection from './HeroSection';
import ShopByCategory from './ShopByCategory';
import WhyChooseUs from './WhyChooseUs';
import MostLovedProducts from './MostLovedProducts';
import Footer from './Footer';
import Testimonials from './Testimonials';
import ShopCollection from './ShopCollection';
import ProcessSteps from './ProcessSteps';
import PromotionalSection from './PromotionalSection';
import Faqs from './Policies/Faqs';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-orange-50 bg-opacity-90">
      <HeroSection />
      <div className="flex flex-col items-center px-4  mx-auto">
        <ShopByCategory />
        <WhyChooseUs />
        <PromotionalSection/>
        <MostLovedProducts />
        {/* <ShopCollection/> */}
        <ProcessSteps/>
        <Testimonials/>
        <Faqs/>
      </div>
      {/* <Footer /> */}
    </div>
  );
};

export default HomePage;
